import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import PropTypes from "prop-types";

const useStyles = createUseStyles({
	root: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		// maxWidth: "50%",
	},
	num: {
		fontFamily: "Inter-SemiBold",
		fontSize: "24px",
		lineHeight: "32px",
		color: "#111827",
	},
	unit: {
		fontFamily: "Inter-Regular",
		fontSize: "14px",
		lineHeight: "20px",
		color: "#6D7482",
		marginLeft: "3px",
	},
	description: {
		fontFamily: "Inter-Regular",
		width: "100%",
		fontSize: "12px",
		lineHeight: "16px",
		color: "#6D7482",
	},
	order: {
		order: 1,
		width: "100%",
		maxWidth: "100%",
	},
});

const MainTariffDescription = (props) => {
	const { num, unit, description, exclusive } = props;
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.root, {
				[classes.order]: exclusive,
			})}
		>
			<div className={classes.num}>{num}</div>
			<span className={classes.unit}>{unit}</span>
			<div className={classes.description}>{description}</div>
		</div>
	);
};

MainTariffDescription.propTypes = {
	num: PropTypes.number,
	unit: PropTypes.string,
	description: PropTypes.string,
	exclusive: PropTypes.bool,
};
export default MainTariffDescription;
